import React from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { Button } from './Button';
import { Dial } from './Dial';
import { NeedFromAbby } from './NeedFromAbby';
import { images } from '../data/images';
type HomeHeroProps = {
  background: 'image' | 'dusk';
};
export function HomeHero({
  background
}: HomeHeroProps) {
  const reduce = useReducedMotion();
  const {
    scrollY
  } = useScroll();
  const rotate = useTransform(scrollY, [0, 900], [0, reduce ? 0 : 24]);
  const withImage = background === 'image';
  return <section aria-labelledby="hero-title" className="relative grid min-h-[calc(100svh-5rem)] lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]" data-id="element-259" data-mp="12vejh1tmhc6f">
      <div className="dusk-field gutter relative flex flex-col justify-center py-[clamp(3.5rem,8vw,9rem)]" data-id="element-260" data-mp="u0gnflv6hjav">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative max-w-[34rem] xl:max-w-[44rem] 2xl:max-w-[56rem]" data-id="element-261" data-mp="f3ftrctffe9r">
          <p className="t-label text-graphite" data-id="element-262" data-mp="1cvxg9xswo6um">Vedic Astrology · Ritual · Spiritual Living</p>
          <h1 id="hero-title" className="t-display mt-7" data-id="element-263" data-mp="1qv6ly3jhjikc">
            Your time.
            <br data-id="element-264" data-mp="1qt3zfthjk7kd" />
            Your twelve.
          </h1>
          <p className="t-lead mt-8 max-w-[42ch] text-graphite" data-id="element-265" data-mp="1mv68al47nbec">
            Modern spiritual living rooted in ancient Vedic wisdom. Know yourself, understand your timing, and live with intention.
          </p>
          <div className="mt-10 flex flex-wrap gap-3" data-id="element-266" data-mp="u6qv844n335n">
            <Button to="/shop" size="lg" data-id="element-267" data-mp="17x4366hj6huz">
              Explore the Shop
            </Button>
            <Button to="/readings#book" variant="outline" size="lg" data-id="element-268" data-mp="136452xwodtqw">
              Book a Reading
            </Button>
          </div>
        </motion.div>
      </div>

      <div className={`relative min-h-[70vw] overflow-hidden sm:min-h-[60vw] lg:min-h-0 ${withImage ? 'bg-stone' : 'dusk-field'}`} data-id="element-269" data-mp="fe6vzekm1fth">
        {withImage && <>
            <img src={images.hero} alt="A woman meditating on a stone ledge above the desert at dusk" className="absolute inset-0 h-full w-full object-cover" data-id="element-270" data-mp="2aiofmcmju4ac" />
            <div aria-hidden="true" className="absolute inset-0 bg-charcoal/20" data-id="element-271" data-mp="2k9iz598eups3" />
            <NeedFromAbby className="absolute bottom-4 left-4 z-10" data-id="element-272" data-mp="2p8cgxduqd2y2">hero lifestyle photo</NeedFromAbby>
          </>}
        <div className="absolute left-1/2 top-[42%] aspect-square w-[min(74%,70vh)] -translate-x-1/2 -translate-y-1/2" data-id="element-273" data-mp="1rl3muugnylkg">
          <motion.div style={{
          rotate
        }} className="h-full w-full" data-id="element-274" data-mp="1wkq5jjf9gu0n">
            <Dial tone={withImage ? 'light' : 'gold'} wordmark label="A slowly sweeping True Twelve dial showing the current time" className="h-full w-full" data-id="element-275" data-mp="21j1fdu5k34iv" />
          </motion.div>
        </div>
      </div>
    </section>;
}